module.exports = __webpack_public_path__ + "static/media/pragna_college.a1f87f0f.png";